<template>
  <section class="not-found-page">
    <vd-error status="404" message="You are looking for something that doesn't exists..." :back-link="backLink" />
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { RouteLocationRaw } from "vue-router";

import links from "@/router/links";

export default defineComponent({
  name: "NotFoundPage",

  setup() {
    const backLink: RouteLocationRaw = { name: links.games.list };

    return {
      backLink,
    };
  },
});
</script>
